import { Checkbox } from '@strata-monorepo/shared-ui/components/ui/checkbox'
import { Label } from '@strata-monorepo/shared-ui/components/ui/label'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'

interface CheckboxItem {
  id: string
  label: string
  checked: boolean
}

interface CheckboxGroupProps {
  options: CheckboxItem[]
  onChange: (id: string, checked: boolean) => void
  className?: string
  /** When true, checkbox appears on the right on mobile and reverts to left on md+ screens */
  reverseOnMobile?: boolean
}

export function CheckboxGroup({
  options,
  onChange,
  className,
  reverseOnMobile = false,
}: CheckboxGroupProps) {
  const handleCheckedChange = (id: string, checked: boolean) => {
    onChange(id, checked)
  }

  const handleKeyDown = (event: React.KeyboardEvent, id: string, checked: boolean) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleCheckedChange(id, !checked)
    }
  }

  return (
    <div
      className={cn(
        'strata:w-full strata:max-w-2xl strata:mx-auto strata:space-y-3 strata:text-left',
        className,
      )}
    >
      {options.map((item) => (
        <div
          key={item.id}
          className={cn(
            'strata:flex strata:items-center strata:gap-4 strata:p-3 strata:rounded-primary strata:border strata:cursor-pointer',
            reverseOnMobile && 'strata:flex-row-reverse strata:md:flex-row',
            item.checked
              ? 'strata:bg-secondary-50 strata:border-secondary-500'
              : 'strata:bg-white strata:border-gray-300 strata:hover:border-secondary-500',
          )}
          role='button'
          tabIndex={0}
          aria-pressed={item.checked}
          onClick={(e) => {
            e.preventDefault()
            handleCheckedChange(item.id, !item.checked)
          }}
          onKeyDown={(e) => handleKeyDown(e, item.id, item.checked)}
        >
          <Checkbox
            id={item.id}
            checked={item.checked}
            className='strata:h-5 strata:w-5 strata:rounded-xs strata:data-[state=checked]:bg-secondary-500 strata:data-[state=checked]:border-secondary-500 strata:border-secondary-500 strata:cursor-pointer'
          />
          <Label
            htmlFor={item.id}
            className='strata:font-bold strata:text-gray-700 strata:text-sm strata:md:text-base strata:cursor-pointer strata:flex-1'
          >
            {item.label}
          </Label>
        </div>
      ))}
    </div>
  )
}
